import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { PublishEventCommandInput, PublishEventCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'publishEvent'];

export function usePublishEvent() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<PublishEventCommandOutput, Error, PublishEventCommandInput>({
    mutationKey: [...MUTATION_PREFIX],
    mutationFn: (input) => client.publishEvent(input),
    retry: 2, // Automatically retry up to 2 times on failure
  });
}
